import axios from "axios";

// Public Master Plans API (see docs: PUBLIC_WEBSITE_MASTER_PLANS_SETUP_GUIDE.pdf).
export const MASTER_API_URL = (
  process.env.REACT_APP_MASTER_API_URL || "https://backend.magicqr.in/api/v1"
).replace(/\/$/, "");

// Signups from this site are provisioned as agencies under Master 1, logging
// into the agency panel on this host.
export const PANEL_HOST = "post.magicbolt.in";

const client = axios.create({ baseURL: MASTER_API_URL, withCredentials: true });

const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

// The API wraps every payload as { success, data }.
const unwrap = (res) => res.data?.data ?? res.data;

export async function getPlans() {
  return unwrap(await client.get("/public/master/plans"));
}

export async function getPlan(id) {
  return unwrap(await client.get(`/public/master/plans/${encodeURIComponent(id)}`));
}

export async function signupAgency({ name, email, password, phone }) {
  const body = { name, email, password, accountType: "agency", host: PANEL_HOST };
  if (phone) body.phone = phone;
  return unwrap(await client.post("/users/signup", body));
}

export async function loginAgency({ email, password }) {
  return unwrap(await client.post("/users/login", { email, password }));
}

export async function createCheckout({ planId, billingInterval, token }) {
  return unwrap(
    await client.post(
      "/public/master/razorpay/checkout",
      { planId, billingInterval },
      { headers: authHeaders(token) }
    )
  );
}

export async function verifyPayment({
  razorpayOrderId,
  razorpaySubscriptionId,
  razorpayPaymentId,
  razorpaySignature,
  planId,
  token,
}) {
  return unwrap(
    await client.post(
      "/public/master/razorpay/verify-payment",
      {
        ...(razorpayOrderId ? { razorpayOrderId } : {}),
        ...(razorpaySubscriptionId ? { razorpaySubscriptionId } : {}),
        razorpayPaymentId,
        razorpaySignature,
        planId,
      },
      { headers: authHeaders(token) }
    )
  );
}

// Login/signup responses have carried the token at `token` in the guide; be
// tolerant of a nested shape so a small backend change doesn't break checkout.
export function extractToken(payload) {
  return payload?.token || payload?.accessToken || payload?.data?.token || null;
}
